import { DeviceTypes } from 'domain/api/graphql/generated';

export enum PlayerTypesInFlow {
  WEBPLAYER = 'WEBPLAYER',
  MOBILE = 'MOBILE',
  VIDEOPLAYER = 'VIDEOPLAYER',
  DESKTOP = 'DESKTOP',
  BOOM_SPEAKER = 'BOOM_SPEAKER',
  ANDROIDBOX = 'ANDROIDBOX',
}

export enum VideoDeviceType {
  Video = 'VIDEO_PLAYER',
}

export enum DeviceTypesInFlow {
  ANDROID = DeviceTypes.Android,
  ANDROIDBOX = DeviceTypes.Androidbox,
  BOOM_SPEAKER = DeviceTypes.BoomSpeaker,
  DESKTOP = DeviceTypes.Desktop,
  IOS = DeviceTypes.Ios,
  WEBPLAYER = DeviceTypes.Webplayer,
  VIDEOPLAYER = VideoDeviceType.Video,
}

export enum SelectPlayerFlowType {
  CREATE_POINT = 'CREATE_POINT',
  CREATE_POINT_WHILE_BINDING_STREAM = 'CREATE_POINT_WHILE_BINDING_STREAM',
  CHANGE_DEVICE = 'CHANGE_DEVICE',
  BIND_STREAM = 'BIND_STREAM',
  FULL_ONBOARDING = 'FULL_ONBOARDING',
}

export enum DeviceBindStatus {
  BINDED = 'binded',
  REQUESTED = 'requested',
}

export type UseSelectPlayerFlowControllerProps = {
  targetStreamId?: string;
  isTemplateMode: boolean;
  selectPlayerFlowType: SelectPlayerFlowType;
};

export type CurrentStreamOnboardingType = {
  id?: string;
};

export type CurrentDeviceOnboardingType = {
  id?: string;
  type?: DeviceTypesInFlow | VideoDeviceType;
  actualType?: DeviceTypesInFlow | VideoDeviceType;
  bindStatus?: DeviceBindStatus;
  requiredVersionUrl?: string;
  lastRequestTime?: string;
};

export type CurrentPointOnboardingType = {
  id?: string;
  address?: string;
  stream?: CurrentStreamOnboardingType;
  device?: CurrentDeviceOnboardingType;
  isEnabled?: boolean;
};

export interface OnboardingActionContextType {
  setInFlow: (inFlow: boolean) => void;
  setFlowType: (flowType: SelectPlayerFlowType) => void;
  setIsTemplateMode: (isTemplateMode: boolean) => void;
  setCurrentPoint: (currentPoint: CurrentPointOnboardingType) => void;
  setCurrentPointStream: (stream: CurrentStreamOnboardingType) => void;
  setCurrentPointDevice: (device: CurrentDeviceOnboardingType) => void;
  setCurrentPointIsEnabled: (isEnabled: boolean) => void;
  clearCurrentPoint: () => void;
  resetState: () => void;
}

export interface OnboardingState {
  inFlow: boolean;
  flowType?: SelectPlayerFlowType;
  isTemplateMode: boolean;
  currentPoint: CurrentPointOnboardingType;
}

export enum OnboardingActionTypes {
  SET_IN_FLOW = 'setInFlow',
  SET_FLOW_TYPE = 'setFlowType',
  SET_IS_TEMPLATE_FLOW = 'setIsTemplateMode',
  SET_CURRENT_POINT = 'setCurrentPoint',
  SET_CURRENT_POINT_STREAM = 'setCurrentPointStream',
  SET_CURRENT_POINT_DEVICE = 'setCurrentPointDevice',
  SET_CURRENT_POINT_IS_ENABLED = 'setCurrentPointIsEnabled',
  RESET_CURRENT_POINT = 'resetCurrentPoint',
  RESET_STATE = 'resetState',
}

export type OnboardingAction =
  | { type: OnboardingActionTypes.SET_IN_FLOW; inFlow: boolean }
  | { type: OnboardingActionTypes.SET_FLOW_TYPE; flowType: SelectPlayerFlowType }
  | { type: OnboardingActionTypes.SET_IS_TEMPLATE_FLOW; isTemplateMode: boolean }
  | { type: OnboardingActionTypes.SET_CURRENT_POINT; currentPoint: CurrentPointOnboardingType }
  | { type: OnboardingActionTypes.SET_CURRENT_POINT_STREAM; stream: CurrentStreamOnboardingType }
  | { type: OnboardingActionTypes.SET_CURRENT_POINT_DEVICE; device: CurrentDeviceOnboardingType }
  | { type: OnboardingActionTypes.SET_CURRENT_POINT_IS_ENABLED; isEnabled: boolean }
  | { type: OnboardingActionTypes.RESET_CURRENT_POINT }
  | { type: OnboardingActionTypes.RESET_STATE };
